import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AdminSidebarLinks from './AdminSidebarLinks';
import MentorSidebarLinks from './MentorSidebarLinks';
import BumdesSidebarLinks from './BumdesSidebarLinks';
import DplSidebarLinks from './DplSidebarLinks';

const Sidebar = ({ isCollapsed, toggleSidebar }) => {
  const { authUser, signOut } = useAuth();
  const rawRole = authUser?.activeSession?.roleCode?.toLowerCase() || '';
  const role = rawRole.includes('bumdes') ? 'bumdes' : rawRole.includes('dpl') ? 'dpl' : rawRole;
  const batch = authUser.activeSession || {};

  return (
    <div
      className={`d-flex flex-column flex-shrink-0 bg-white shadow-sm sidebar-container rounded-4 border ${isCollapsed ? 'sidebar-collapsed' : ''}`}
      style={{
        width: isCollapsed ? '80px' : '280px',
        height: 'calc(100vh - 48px)',
        maxHeight: 'calc(100vh - 48px)',
        position: 'sticky',
        top: '24px',
        zIndex: 1000,
      }}
    >
      {/* Header & Toggle */}
      <div
        className={`p-3 d-flex align-items-center ${isCollapsed ? 'justify-content-center' : 'justify-content-between border-bottom mb-2'}`}
        style={{ minHeight: '74px' }}
      >
        {!isCollapsed && (
          <div className='d-flex align-items-center gap-3 animate-slide-up flex-grow-1 overflow-hidden pe-2'>
            <div className='bg-primary bg-opacity-10 p-2 rounded-3 shadow-sm flex-shrink-0'>
              <i className='bi bi-shield-check text-primary fs-5'></i>
            </div>
            <div className='sidebar-collapsed-text flex-grow-1 overflow-hidden'>
              <h6
                className='fw-bold text-dark mb-0 text-truncate'
                style={{ fontSize: '0.9rem', letterSpacing: '0.3px' }}
              >
                {role === 'admin' ? 'ADMIN HUB' : role === 'bumdes' ? 'BUMDES HUB' : role === 'dpl' ? 'DPL HUB' : 'MENTOR HUB'}
              </h6>
              <small
                className='text-muted fw-medium d-block text-truncate'
                style={{ fontSize: '0.7rem' }}
                title={
                  role === 'admin'
                    ? authUser?.activeSession?.roleName || 'Administrator'
                    : role === 'bumdes'
                    ? 'Mitra BUMDes'
                    : role === 'dpl'
                    ? 'Dosen Pembimbing Lapangan'
                    : `${batch?.programName} - ${batch?.batchName}`
                }
              >
                {role === 'admin' ? (
                  authUser?.activeSession?.roleName || 'Administrator'
                ) : role === 'bumdes' ? (
                  'Mitra BUMDes'
                ) : role === 'dpl' ? (
                  'Dosen Pembimbing Lapangan'
                ) : (
                  <>
                    {batch?.programName} - {batch?.batchName}
                  </>
                )}
              </small>
            </div>
          </div>
        )}
        <button
          className='sidebar-toggle-btn flex-shrink-0'
          onClick={toggleSidebar}
          title={isCollapsed ? 'Show Sidebar' : 'Hide Sidebar'}
        >
          <i
            className={`bi bi-${isCollapsed ? 'chevron-right' : 'chevron-left'} fs-6`}
          ></i>
        </button>
      </div>

      {/* Nav Links list */}
      <div className='nav flex-column flex-nowrap mb-auto sidebar-scroll px-3 overflow-y-auto overflow-x-hidden'>
        {role === 'admin' && (
          <AdminSidebarLinks authUser={authUser} isCollapsed={isCollapsed} />
        )}
        {role === 'mentor' && (
          <MentorSidebarLinks isCollapsed={isCollapsed} />
        )}
        {role === 'bumdes' && (
          <BumdesSidebarLinks
            authUser={authUser}
            isCollapsed={isCollapsed}
          />
        )}
        {role === 'dpl' && (
          <DplSidebarLinks isCollapsed={isCollapsed} />
        )}
      </div>

      {/* Sidebar Footer / Profile Menu */}
      <div className='p-3 border-top'>
        <div className='dropup'>
          <a
            href='/#'
            className='d-flex align-items-center link-body-emphasis text-decoration-none dropdown-toggle px-2 py-2 rounded hover-bg-light transition-all'
            data-bs-toggle='dropdown'
            aria-expanded='false'
          >
            <div
              className='rounded-circle me-2 d-flex align-items-center justify-content-center bg-primary text-white shadow-sm fw-bold'
              style={{ width: 40, height: 40, minWidth: 40, fontSize: '1rem' }}
            >
              {authUser?.fullName?.charAt(0)?.toUpperCase() || 'U'}
            </div>
            <div className='d-flex flex-column overflow-hidden text-start sidebar-collapsed-text ms-2'>
              <span
                className='fw-bold text-dark text-truncate small'
                style={{ maxWidth: '140px' }}
              >
                {authUser?.fullName}
              </span>
              <small
                className='text-muted'
                style={{ fontSize: '0.75rem' }}
              >
                {role === 'admin' ? (authUser?.activeSession?.roleName || 'Administrator') : role === 'bumdes' ? 'Mitra BUMDes' : role === 'dpl' ? 'Dosen Pembimbing' : 'Mentor'}
              </small>
            </div>
          </a>
          <ul className='dropdown-menu dropdown-menu-start text-small shadow-lg border-0 rounded-4 p-2 mb-2'>
            <li>
              <h6
                className='dropdown-header text-uppercase extra-small fw-bold text-primary'
                style={{ fontSize: '0.7rem' }}
              >
                Account
              </h6>
            </li>
            <li className='my-1'>
              <NavLink
                className='dropdown-item d-flex align-items-center rounded-3 py-2'
                to={`/${role}/profile`}
              >
                <i className='bi bi-person me-2 text-primary'></i> Profile
              </NavLink>
            </li>
            <li>
              <hr className='dropdown-divider opacity-50' />
            </li>
            <li className='mt-1'>
              <button
                onClick={signOut}
                className='dropdown-item d-flex align-items-center rounded-3 py-2 text-danger hover-bg-danger-subtle'
                type='button'
              >
                <i className='bi bi-box-arrow-right me-2'></i> Sign out
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
